import React from 'react';
import { IIllustrationProps } from './type';

const SpacerDoodle: React.FC<IIllustrationProps> = ({
  width,
  height,
  color: _color = '#000',
  UNSAFE_className,
  ...props
}) => (
  <svg
    width={width || '64'}
    height={height || '64'}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={UNSAFE_className || ''}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.1433 26.5583C38.5163 26.2448 37.8893 25.9313 37.3072 25.6627C37.2281 24.8189 37.1955 24.0063 37.1639 23.2155C37.1418 22.6631 37.1201 22.1213 37.0832 21.5871C35.874 13.7942 32.0224 7.92718 24.5878 4.70254C22.438 3.76202 20.1091 3.40373 17.7354 3.76202C16.7054 3.89638 15.944 4.56818 16.1231 5.68785C16.2844 6.65565 16.9903 6.67944 17.8159 6.70727C17.9072 6.71035 18 6.71348 18.0937 6.71794C19.8404 6.76272 21.7214 6.8523 23.3338 7.47931C30.0965 10.0321 34.6648 17.825 33.9034 25.3044C33.7295 25.3478 33.5477 25.3913 33.3606 25.4361C32.7765 25.5757 32.1402 25.7279 31.5297 25.9314C28.3499 27.0958 26.2001 30.1413 26.3793 33.0524C26.5584 35.9636 28.7977 37.5311 31.3953 36.1875C32.7837 35.5157 33.9482 34.1721 34.9335 32.9181C35.4883 32.1784 35.8734 31.2902 36.2785 30.3557C36.4621 29.9323 36.6498 29.4994 36.8593 29.0664C38.8299 29.8726 40.5766 30.9923 41.5619 32.7837C42.5838 34.6451 43.4273 36.6552 44.262 38.6443C44.4515 39.0961 44.6407 39.5467 44.8313 39.9944C44.9635 40.2965 45.0479 40.6226 45.1316 40.9456C45.2463 41.3887 45.3596 41.8263 45.5927 42.1889C45.8614 42.592 46.6228 42.9951 47.1154 42.9055C47.6081 42.8159 48.1903 42.2337 48.3247 41.741C48.5038 41.114 48.3695 40.3079 48.1455 39.6808C47.3842 37.5759 46.5332 35.4709 45.6823 33.3659C44.3835 30.2757 42.0546 28.1259 39.1434 26.5584L39.1433 26.5583ZM29.6039 33.4555C31.6641 32.4702 32.515 30.9923 33.0077 29.0664C30.5444 29.7382 29.8726 30.5892 29.6039 33.4555ZM25.7522 47.8773C24.862 47.8773 24.1404 48.599 24.1404 49.4891C24.1404 50.3793 24.862 51.101 25.7522 51.101C28.4922 51.101 31.1812 51.4835 33.7536 52.6482C36.3142 53.8075 38.8539 55.7845 41.2361 59.1154C41.754 59.8394 42.7607 60.0066 43.4848 59.4888C44.2088 58.9709 44.376 57.9642 43.8582 57.2401C41.1795 53.4947 38.2105 51.1274 35.0832 49.7115C31.9676 48.3009 28.7896 47.8773 25.7522 47.8773Z"
      fill="black"
    />
  </svg>
);

export default SpacerDoodle;
